exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".K8sResources {\n  width: 100%;\n}\n.K8sResources .StandardFieldLayout {\n  width: 25%;\n}\n.K8sResources .StandardFieldLayout .StandardFieldLayout_Label {\n  min-width: 72px;\n}\n", ""]);

